module.exports = __webpack_public_path__ + "img/20190715154720097.97e23beb.png";